export default class userinfo {
    id: number;
    userName: string;
    name: string;
}